<template>
  <div class="main-container analfe">

    <!-- ===== Hero ===== -->
    <section class="analfe-hero">
      <div class="analfe-hero__shapes" aria-hidden="true">
        <span class="shape shape--blue"></span>
        <span class="shape shape--yellow"></span>
        <span class="shape shape--red"></span>
      </div>

      <div class="analfe-wrap analfe-hero__inner">
        <img
          class="analfe-hero__foto"
          src="../assets/img/mi_perfil_avatar.jpg"
          alt="Adrián Coria Fernández"
          width="512"
          height="512"
          fetchpriority="high"
        />

        <div class="analfe-hero__texto">
          <p class="analfe-hero__eyebrow">
            25° Congreso Nacional Analfe · Cartagena, Colombia
          </p>

          <h1 class="analfe-hero__title">
            Gracias por acompañarme en Analfe 2025
          </h1>

          <p class="analfe-hero__name">Adrián Coria Fernández</p>
          <p class="analfe-hero__role">Líder de Innovación, Valladolid Caja Financiera</p>

          <p class="analfe-hero__lead">
            Compartir el camino de la innovación con ustedes fue un privilegio. Si algo de
            la charla te movió algo —una idea, una duda, un desacuerdo— me encantaría leerlo.
            Todos los campos son opcionales; escribe solo lo que quieras.
          </p>
        </div>
      </div>
    </section>

    <!-- ===== Formulario ===== -->
    <section class="analfe-body">
      <div class="analfe-wrap">

        <div class="analfe-card">
          <form class="analfe-form" novalidate @submit.prevent="enviar">

            <!-- 1. Qué te llevas -->
            <div class="field">
              <label class="field__label" for="f-llevas">¿Qué te llevas de la charla?</label>
              <textarea
                id="f-llevas"
                name="Que te llevas"
                v-model="form.llevas"
                rows="4"
                placeholder="Una idea, una frase, algo que te resonó…"
              ></textarea>
            </div>

            <!-- 2. Calificación -->
            <fieldset class="field field--rating">
              <legend class="field__label">¿Qué te pareció?</legend>
              <div class="rating" role="group" aria-label="Calificación del 1 al 5">
                <button
                  v-for="op in opciones"
                  :key="op.valor"
                  type="button"
                  class="rating__item"
                  :class="{ 'is-active': form.puntuacion === op.valor }"
                  :aria-pressed="form.puntuacion === op.valor ? 'true' : 'false'"
                  :aria-label="op.valor + ' de 5 — ' + op.texto"
                  @click="elegir(op.valor)"
                >
                  <span class="rating__face" aria-hidden="true">{{ op.cara }}</span>
                  <span class="rating__text">{{ op.texto }}</span>
                </button>
              </div>
              <input type="hidden" name="Calificacion" :value="puntuacionTexto" />
            </fieldset>

            <!-- 3. Pregunta -->
            <div class="field">
              <label class="field__label" for="f-pregunta">
                ¿Algo que te gustaría preguntarme o profundizar?
              </label>
              <textarea
                id="f-pregunta"
                name="Pregunta"
                v-model="form.pregunta"
                rows="4"
                placeholder="Con gusto lo retomamos…"
              ></textarea>
            </div>

            <!-- 4. Datos opcionales -->
            <div class="par">
              <div class="field">
                <label class="field__label" for="f-nombre">
                  Nombre <span class="field__hint">(opcional)</span>
                </label>
                <input
                  id="f-nombre"
                  name="Nombre"
                  type="text"
                  autocomplete="name"
                  v-model.trim="form.nombre"
                  placeholder="Cómo te llamas"
                />
              </div>

              <div class="field">
                <label class="field__label" for="f-org">
                  Fondo u organización <span class="field__hint">(opcional)</span>
                </label>
                <input
                  id="f-org"
                  name="Fondo u organizacion"
                  type="text"
                  autocomplete="organization"
                  v-model.trim="form.organizacion"
                  placeholder="Dónde trabajas"
                />
              </div>
            </div>

            <div class="field">
              <label class="field__label" for="f-email">
                Correo <span class="field__hint">(opcional)</span>
              </label>
              <input
                id="f-email"
                name="Correo"
                type="email"
                inputmode="email"
                autocomplete="email"
                v-model.trim="form.email"
                :class="{ 'has-error': errorCorreo }"
                :aria-invalid="errorCorreo ? 'true' : 'false'"
                placeholder="tucorreo@ejemplo.com"
              />
              <p class="field__note">Solo si quieres que te responda.</p>
              <p v-if="errorCorreo" class="field__error" role="alert">
                Ese correo no se ve bien. Revísalo o déjalo en blanco.
              </p>
            </div>

            <button type="submit" class="btn-primario" :disabled="enviando">
              {{ enviando ? 'Enviando…' : 'Enviar' }}
            </button>

            <!-- Estados -->
            <div class="estado" aria-live="polite">
              <p v-if="estado === 'exito'" class="estado__msg estado__msg--ok">
                ¡Gracias! Recibí tu mensaje. Si dejaste tu correo, te respondo pronto.
              </p>
              <p v-else-if="estado === 'vacio'" class="estado__msg estado__msg--warn">
                Cuéntame algo antes de enviar —aunque sea solo tu calificación.
              </p>
              <p v-else-if="estado === 'correo'" class="estado__msg estado__msg--warn">
                Revisa el correo, por favor.
              </p>
              <p v-else-if="estado === 'sin-endpoint'" class="estado__msg estado__msg--warn">
                El formulario aún no está conectado. Falta la URL del Apps Script.
              </p>
              <p v-else-if="estado === 'error'" class="estado__msg estado__msg--error">
                No se pudo enviar. Revisa tu conexión e inténtalo de nuevo.
              </p>
            </div>

          </form>
        </div>

        <!-- ===== LinkedIn ===== -->
        <a
          class="btn-linkedin"
          href="https://www.linkedin.com/in/adriancoriafer/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg class="btn-linkedin__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path fill="currentColor" d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05a3.75 3.75 0 0 1 3.37-1.85c3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.07 2.07 0 1 1 0-4.13 2.07 2.07 0 0 1 0 4.13ZM7.12 20.45H3.55V9h3.57v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z"/>
          </svg>
          Conectemos en LinkedIn
        </a>

      </div>
    </section>

  </div>
</template>

<script>
// ⚠️ PENDIENTE: pegar aquí la URL del Web App de Google Apps Script.
//    Se obtiene en: Apps Script → Implementar → Nueva implementación →
//    Aplicación web (Ejecutar como: yo · Acceso: cualquier usuario).
//    Debe terminar en /exec (no en /dev).
//    El código del script está en pagina/apps-script/analfe-feedback.gs
const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzSXnPXD6e3lh77lzTZ2GyhXEkrVI6SEdZOKLChIsmWXj9qkT1wgsfmo8qJ34WGC6FJ/exec'

const SIN_RESPUESTA = '(sin respuesta)'

export default {
  name: 'AcercaDeMi',

  data() {
    return {
      enviando: false,
      estado: '',
      form: {
        llevas: '',
        puntuacion: null,
        pregunta: '',
        nombre: '',
        organizacion: '',
        email: '',
      },
      opciones: [
        { valor: 1, cara: '😕', texto: 'Poco' },
        { valor: 2, cara: '🙂', texto: 'Regular' },
        { valor: 3, cara: '😊', texto: 'Bien' },
        { valor: 4, cara: '😃', texto: 'Muy bien' },
        { valor: 5, cara: '🤩', texto: 'Excelente' },
      ],
    }
  },

  computed: {
    errorCorreo() {
      const v = this.form.email
      if (!v) return false
      return !/^\S+@\S+\.\S+$/.test(v)
    },

    puntuacionTexto() {
      if (!this.form.puntuacion) return ''
      const op = this.opciones.find(o => o.valor === this.form.puntuacion)
      return op ? `${op.valor}/5 — ${op.texto}` : ''
    },

    todoVacio() {
      const f = this.form
      return !f.puntuacion && !f.llevas.trim() && !f.pregunta.trim() &&
             !f.nombre && !f.organizacion && !f.email
    },

    // Evita envíos al vacío si todavía no se pega la URL del script.
    sinCredenciales() {
      return !APPS_SCRIPT_URL || APPS_SCRIPT_URL.startsWith('TU_')
    },
  },

  methods: {
    elegir(valor) {
      // Segundo clic sobre la misma carita la deselecciona.
      this.form.puntuacion = this.form.puntuacion === valor ? null : valor
      if (this.estado === 'vacio') this.estado = ''
    },

    async enviar() {
      this.estado = ''

      if (this.todoVacio) {
        this.estado = 'vacio'
        return
      }
      if (this.errorCorreo) {
        this.estado = 'correo'
        return
      }
      if (this.sinCredenciales) {
        this.estado = 'sin-endpoint'
        return
      }

      this.enviando = true
      try {
        // Estas claves son los nombres de columna que espera el Apps Script.
        // Si cambias una aquí, cámbiala también en analfe-feedback.gs
        const res = await fetch(APPS_SCRIPT_URL, {
          method: 'POST',
          // Este Content-Type está en la lista segura de CORS, así que el
          // navegador NO manda preflight OPTIONS — que es justo lo que Apps
          // Script no sabe responder. No lo cambies a application/json.
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: this.codificar({
            calificacion: this.puntuacionTexto || SIN_RESPUESTA,
            que_se_lleva: this.form.llevas.trim() || SIN_RESPUESTA,
            pregunta: this.form.pregunta.trim() || SIN_RESPUESTA,
            nombre: this.form.nombre || 'Anónimo',
            organizacion: this.form.organizacion || SIN_RESPUESTA,
            correo: this.form.email || SIN_RESPUESTA,
            origen: 'QR ponencia Analfe 2025',
          }),
        })

        const datos = await res.json()

        if (res.ok && datos && datos.ok) {
          this.estado = 'exito'
          this.limpiar()
        } else {
          this.estado = 'error'
        }
      } catch (e) {
        this.estado = 'error'
      } finally {
        this.enviando = false
      }
    },

    // Serializa a x-www-form-urlencoded sin depender de URLSearchParams.
    codificar(datos) {
      return Object.keys(datos)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(datos[k]))
        .join('&')
    },

    limpiar() {
      this.form.llevas = ''
      this.form.puntuacion = null
      this.form.pregunta = ''
      this.form.nombre = ''
      this.form.organizacion = ''
      this.form.email = ''
    },
  },

  metaInfo: {
    title: 'Leonix | Acerca de mí — Analfe 2025',
    htmlAttrs: { lang: 'es-MX' },
    meta: [
      {
        name: 'description',
        content:
          'Gracias por acompañarme en el 25° Congreso Nacional Analfe. Déjame tu impresión de la charla o tu pregunta. Adrián Coria Fernández, Valladolid Caja Financiera.',
      },
      { name: 'theme-color', content: '#101c4d' },
    ],
  },
}
</script>

<style lang="scss" scoped>
// ── Paleta Analfe 2025 ────────────────────────────────────────────────────
$navy:       #101c4d;
$navy-deep:  #0a1234;
$blue:       #2b57d6;
$blue-dark:  #2246ad;
$blue-soft:  #7eb6f5;
$yellow:     #ffc220;
$red:        #e4222e;
$ink:        #1b2340;
$muted:      #5c6584;
$line:       #e3e7f2;
$paper:      #f4f6fb;

// Mobile-first: todo se escribe para celular y crece con min-width.
.analfe {
  background: $paper;
  color: $ink;
}

.analfe-wrap {
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0 20px;
}

// ── Hero ──────────────────────────────────────────────────────────────────
.analfe-hero {
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, $navy 0%, $navy-deep 100%);
  color: #fff;
  padding: 40px 0 76px;

  // Retrato circular: 512px de origen. En móvil va arriba; en escritorio,
  // al lado del texto (ver la media query de 768px).
  &__foto {
    display: block;
    width: 128px;
    height: 128px;
    margin: 0 0 22px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.32);
  }

  &__inner {
    position: relative;
    z-index: 1;
  }

  // Paralelogramos inclinados, guiño a la gráfica del congreso.
  &__shapes {
    position: absolute;
    inset: 0;
    pointer-events: none;

    .shape {
      position: absolute;
      display: block;
      transform: skewX(-20deg);
      border-radius: 2px;
    }
    .shape--blue {
      top: -40px; right: -30px;
      width: 130px; height: 210px;
      background: rgba($blue-soft, 0.16);
    }
    .shape--yellow {
      bottom: 24px; right: 34px;
      width: 46px; height: 88px;
      background: rgba($yellow, 0.5);
    }
    .shape--red {
      bottom: -20px; right: -8px;
      width: 34px; height: 70px;
      background: rgba($red, 0.45);
    }
  }

  &__eyebrow {
    margin: 0 0 18px;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    color: $blue-soft;
  }

  &__title {
    margin: 0 0 22px;
    font-size: 1.85rem;
    line-height: 1.22;
    font-weight: 700;
    color: #fff;
    max-width: 15ch;
  }

  &__name {
    margin: 0;
    font-size: 1.06rem;
    font-weight: 700;
    color: #fff;
  }

  &__role {
    margin: 2px 0 20px;
    font-size: 0.92rem;
    color: rgba(255, 255, 255, 0.72);
  }

  &__lead {
    margin: 0;
    font-size: 1rem;
    line-height: 1.68;
    color: rgba(255, 255, 255, 0.86);
    border-left: 3px solid $yellow;
    padding-left: 16px;
  }
}

// ── Cuerpo ────────────────────────────────────────────────────────────────
.analfe-body {
  padding-bottom: 48px;
}

.analfe-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid $line;
  box-shadow: 0 10px 30px rgba(16, 28, 77, 0.09);
  padding: 26px 20px;
  margin-top: -40px; // se monta sobre el hero
  position: relative;
  z-index: 2;
}

// ── Campos ────────────────────────────────────────────────────────────────
.field {
  margin-bottom: 22px;
  border: 0;
  padding: 0;
  min-width: 0; // fieldset no encoge sin esto

  &__label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.94rem;
    font-weight: 600;
    line-height: 1.4;
    color: $ink;
  }

  &__hint {
    font-weight: 400;
    color: $muted;
  }

  &__note {
    margin: 7px 0 0;
    font-size: 0.82rem;
    color: $muted;
  }

  &__error {
    margin: 7px 0 0;
    font-size: 0.85rem;
    font-weight: 600;
    color: $red;
  }

  input[type='text'],
  input[type='email'],
  textarea {
    display: block;
    width: 100%;
    padding: 13px 14px;
    font-family: inherit;
    font-size: 16px; // 16px evita el zoom automático en iOS
    line-height: 1.5;
    color: $ink;
    background: #fff;
    border: 1px solid $line;
    border-radius: 9px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
    -webkit-appearance: none;

    &::placeholder { color: #a3abc4; }

    &:focus {
      outline: none;
      border-color: $blue;
      box-shadow: 0 0 0 3px rgba($blue, 0.16);
    }

    &.has-error {
      border-color: $red;
      &:focus { box-shadow: 0 0 0 3px rgba($red, 0.14); }
    }
  }

  textarea {
    resize: vertical;
    min-height: 108px;
  }
}

// ── Caritas ───────────────────────────────────────────────────────────────
.rating {
  display: flex;
  gap: 6px;

  &__item {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 10px 2px;
    background: #fff;
    border: 1px solid $line;
    border-radius: 10px;
    cursor: pointer;
    transition: border-color 0.15s ease, background 0.15s ease, transform 0.1s ease;
    -webkit-tap-highlight-color: transparent;

    &:focus-visible {
      outline: none;
      border-color: $blue;
      box-shadow: 0 0 0 3px rgba($blue, 0.16);
    }

    &:active { transform: scale(0.96); }

    &.is-active {
      border-color: $blue;
      background: rgba($blue, 0.06);

      .rating__text { color: $blue; font-weight: 700; }
      .rating__face { transform: scale(1.14); }
    }
  }

  &__face {
    font-size: 1.5rem;
    line-height: 1;
    transition: transform 0.15s ease;
  }

  &__text {
    font-size: 0.62rem;
    line-height: 1.15;
    text-align: center;
    color: $muted;
  }
}

// ── Botones ───────────────────────────────────────────────────────────────
.btn-primario {
  display: block;
  width: 100%;
  padding: 15px 20px;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  background: $blue;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.18s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover:not(:disabled) { background: $blue-dark; }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba($blue, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.btn-linkedin {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 22px;
  padding: 15px 20px;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  background: $navy;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.18s ease;

  &:hover,
  &:focus { color: #fff; background: lighten($navy, 8%); text-decoration: none; }

  &__icon {
    width: 19px;
    height: 19px;
    flex-shrink: 0;
  }
}

// ── Estados del envío ─────────────────────────────────────────────────────
.estado:empty { display: none; }

.estado__msg {
  margin: 16px 0 0;
  padding: 12px 14px;
  border-radius: 9px;
  font-size: 0.92rem;
  line-height: 1.55;
  border-left: 3px solid;

  &--ok {
    color: #14532d;
    background: #e9f8ee;
    border-color: #16a34a;
  }
  &--warn {
    color: #7a4b00;
    background: rgba($yellow, 0.16);
    border-color: $yellow;
  }
  &--error {
    color: #8a1219;
    background: rgba($red, 0.09);
    border-color: $red;
  }
}

// ── Tablet / escritorio ───────────────────────────────────────────────────
@media (min-width: 576px) {
  .analfe-hero {
    padding: 56px 0 88px;

    &__foto {
      width: 148px;
      height: 148px;
    }

    &__title { font-size: 2.3rem; }
  }

  .analfe-card { padding: 34px 32px; }

  .rating__text { font-size: 0.72rem; }
}

// A partir de tablet el contenido se ensancha y el retrato pasa a la
// izquierda del saludo: se aprovecha el ancho en vez de dejar aire muerto.
@media (min-width: 768px) {
  .analfe-wrap { max-width: 940px; }

  .analfe-hero {
    padding: 64px 0 96px;

    &__inner {
      display: grid;
      grid-template-columns: auto 1fr;
      align-items: center;
      column-gap: 46px;
    }

    &__foto {
      width: 210px;
      height: 210px;
      margin: 0;
      border-width: 4px;
    }

    &__title {
      font-size: 2.5rem;
      max-width: 17ch;
    }
  }

  // Nombre y organización comparten renglón.
  .par {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 20px;
  }
}

@media (min-width: 992px) {
  .analfe-hero {
    &__inner { column-gap: 56px; }

    &__foto {
      width: 250px;
      height: 250px;
    }

    &__title { font-size: 2.85rem; }
  }
}

// Respeta a quien pide menos movimiento.
@media (prefers-reduced-motion: reduce) {
  .rating__item,
  .rating__face,
  .btn-primario,
  .btn-linkedin,
  .field input,
  .field textarea {
    transition: none;
  }
}
</style>
